
































































import Vue from "vue";
// TODO : eslintでno-unused-varsのwarningが出ているので、Vue3へのアップデート時に対応検討する
import Course, { ProjectCourse } from "@components/partials/public/projects/Course.vue";

type DataType = {
  projectCourse: ProjectCourse
}

export default Vue.extend({
  components: {
    Course
  },
  props: {
    projectCourseJsonString: {
      type: String,
      required: true,
    }
  },
  // TODO : DataTypeの型判定が機能していないので使い方調べる
  data(): DataType {
    const projectCourse = JSON.parse(this.projectCourseJsonString);
    return {
      projectCourse
    };
  },
  computed: {
    investable_limit_over_the_same_company(): boolean {
      return !this.projectCourse.investable_in_the_same_company
    },
    can_not_apply_waiting_list(): boolean {
      return !this.projectCourse.can_apply_waiting_list
    }
  },
  methods: {
    modalShow(): void {
      this.$modal.show('applyWaitingListModalModal');
    },
  }
});
